module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/faq-hero-tablet-2024-51d1ebc6723a190ee76cbde121db0a8a.webp";